import React from 'react';

import {NavigationLink} from './NavigationLink';
import {SCREEN_NAMES} from '../routes';
import Environment from '../../models/Environment';
import {useAuth} from '../../contexts';

export type AppNavigationProps = {
    dark?: boolean;
    onNavigateToScreen: (screenName: string) => void;
    onNavigateToLocationsUrl: () => void;
    onNavigateToViewResultsUrl: () => void;
};
export const AppNavigation = (props: AppNavigationProps) => {
    const {dark, onNavigateToScreen, onNavigateToLocationsUrl, onNavigateToViewResultsUrl} = props;
    const {session} = useAuth();

    const serviceAreasEnabled = session?.appConfig.serviceAreasEnabled;

    return (
        <>
            {Environment.isDevelopmentMode &&
                <NavigationLink screen={SCREEN_NAMES.DEBUG} label={'Dev Tools'} onNavigate={onNavigateToScreen}/>
            }
            <NavigationLink dark={dark} screen={SCREEN_NAMES.BROWSE} label={'Browse Tests'}
                            onNavigate={onNavigateToScreen}/>
            <NavigationLink dark={dark} screen={SCREEN_NAMES.HOW_IT_WORKS} label={'How It Works'}
                            onNavigate={onNavigateToScreen}/>
            <NavigationLink dark={dark} screen={SCREEN_NAMES.HELP} label={'Help / FAQ'}
                            onNavigate={onNavigateToScreen}/>
            <NavigationLink
                dark={dark}
                screen={SCREEN_NAMES.LAB_LOCATIONS}
                label={'Lab Locations'}
                onNavigate={onNavigateToLocationsUrl}
                visible={!serviceAreasEnabled}
            />
            <NavigationLink dark={dark} screen={SCREEN_NAMES.SERVICE_AREAS} label={'Service Areas'}
                            onNavigate={onNavigateToScreen} visible={!!serviceAreasEnabled}/>
            <NavigationLink dark={dark} screen={SCREEN_NAMES.CONTACT_US} label={'Contact Us'}
                            onNavigate={onNavigateToScreen}/>
            <NavigationLink
                dark={dark}
                screen={SCREEN_NAMES.RESULTS}
                label={'View Results'}
                onNavigate={onNavigateToViewResultsUrl}
            />
        </>
    );
};
